/**
 * The modifier key this keyboard actually has.
 *
 * The shell binds both Meta and Control, so the shortcut WORKS everywhere — but
 * a chip reading `⌘K` on a Windows machine names a key that is not on the board.
 * This product's users are on Windows and Android, so the Mac glyph is the
 * exception rather than the default.
 *
 * Not translated: `Ctrl` and `⌘` are engravings on physical keys, not words.
 */
export function shortcutHint(): string {
  // `navigator.platform` is deprecated but is the only synchronous, typed signal;
  // userAgentData is Chromium-only and async for platform details.
  const mac = /mac|iphone|ipad|ipod/i.test(navigator.platform);
  return mac ? '⌘K' : 'Ctrl K';
}
